/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/image/unsplashattribution/unsplash_attribution_styles';



/* ========== ~~~~~~~~~~ UNSPLASH ATTRIBUTION ~~~~~~~~~~ ========== */
const UnsplashAttribtution = (props) => {
    return (
        <div className={`unsplash_attribution ${props.classes.unsplash_attribution}`} style={{width:`${props.adjustedWidth}px`, pointerEvents: props.linkEnabled==='none' ? 'auto' : 'none'}}>
                <a target='_blank' href={props.attribution.linkToProfile}><b>{props.attribution.photographer}</b></a>
        </div>
    );
}



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
export default injectSheet(styles)(UnsplashAttribtution);